import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Cartao from "../../../../components/Authenticated/MinhaConta/MetodosDePagamento/Cartao";
import api from "../../../../services/api";

const AdicionarCartao = () => {
  const navigate = useNavigate();
  const [localCartao, setLocalCartao] = useState({
    numero: "",
    nome: "",
    cpf_titular: "",
    validade: "",
    cvv: ""
  });
  const [loading, setLoading] = useState(false);

  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const token = localStorage.getItem("token");

  // Preenche o CPF do titular só uma vez
  useEffect(() => {
    const cpf = localStorage.getItem("cpfTitular") || "50774721812";
    if (cpf) {
      setLocalCartao(prev => ({ ...prev, cpf_titular: cpf }));
    }
  }, []); // executa apenas uma vez

  const Voltar = () => {
    navigate("/area-restrita/minha-conta/metodos-pagamento");
  };

  const handleCampoChange = (campo, valor) => {
    setLocalCartao(prev => ({ ...prev, [campo]: valor }));
  };

  const formatDate = (value) => {
    let input = value.replace(/\D/g, "").slice(0, 6);
    let formatted = input;
    if (input.length >= 3) {
      formatted = `${input.slice(0, 2)}/${input.slice(2)}`;
    }
    const mes = parseInt(input.slice(0, 2), 10);
    if (mes > 12) formatted = `12/${input.slice(2)}`;
    handleCampoChange("validade", formatted);
  };

  const formatCVV = (value) => {
    const input = value.replace(/\D/g, "").slice(0, 3);
    handleCampoChange("cvv", input);
  };

  const enviarCartao = async () => {
    if (!localCartao.numero || !localCartao.nome || !localCartao.cpf_titular || !localCartao.validade || !localCartao.cvv) {
      alert("Preencha todos os campos corretamente.");
      return;
    }

    try {
      setLoading(true);
      const { data } = await api.post(
        `cliente/cartoes/${usuarioStorage._id}`,
        { novoCartao: localCartao },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log("Resposta do backend:", data);

      if (!data.error) {
        alert("Cartão cadastrado com sucesso!");
        navigate("/area-restrita/minha-conta/metodos-pagamento");
      } else {
        alert(data.message || "Erro ao cadastrar cartão.");
      }
    } catch (err) {
      console.error("Erro ao cadastrar cartão:", err);
      alert("Erro ao cadastrar cartão. Verifique os dados e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={Voltar}
        className="absolute top-3 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9 h-9 hover:bg-[#00575e] transition"
      >
        <ChevronLeft size={20} color="#fff" />
      </button>

      <div className="bg-gray-100 min-h-svh">
          <div className="relative flex flex-col items-center w-full max-w-lg mx-auto py-6">
          <Cartao cartao={localCartao} />

          <h2 className="text-2xl font-bold text-center mt-10 mb-6 text-gray-800">
            Cadastre o seu novo cartão
          </h2>

          <div className="flex flex-col gap-2 w-full items-center">
            <input
              className="w-[85%] p-3 border rounded-xl shadow-sm focus:ring-2 focus:ring-[#003D42] outline-none"
              maxLength={16}
              placeholder="Número do cartão"
              value={localCartao.numero}
              onChange={(e) => handleCampoChange("numero", e.target.value.replace(/\D/g, ""))}
            />

            <input
              className="w-[85%] p-3 border rounded-xl shadow-sm focus:ring-2 focus:ring-[#003D42] outline-none"
              placeholder="Nome no cartão"
              value={localCartao.nome}
              onChange={(e) => handleCampoChange("nome", e.target.value)}
            />

            <input
              className="w-[85%] p-3 border rounded-xl shadow-sm focus:ring-2 focus:ring-[#003D42] outline-none"
              placeholder="CPF do titular"
              value={localCartao.cpf_titular}
              onChange={(e) => handleCampoChange("cpf_titular", e.target.value)}
            />

            <div className="flex justify-between w-[85%] gap-2">
              <input
                className="w-[50%] p-3 border rounded-xl shadow-sm focus:ring-2 focus:ring-[#003D42] outline-none"
                placeholder="Validade (MM/AAAA)"
                maxLength={7}
                value={localCartao.validade}
                onChange={(e) => formatDate(e.target.value)}
              />
              <input
                className="w-[50%] p-3 border rounded-xl shadow-sm focus:ring-2 focus:ring-[#003D42] outline-none"
                placeholder="CVV"
                maxLength={3}
                value={localCartao.cvv}
                onChange={(e) => formatCVV(e.target.value)}
              />
            </div>
          </div>

          <button
            className={`w-[90%] mt-6 bg-[#003D42] text-white p-3 rounded-2xl shadow-md hover:bg-[#00575e] transition font-medium ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={enviarCartao}
            disabled={loading}
          >
            {loading ? "Enviando..." : "Adicionar cartão"}
          </button>
        </div>
      </div>
    </>
  );
};

export default AdicionarCartao;
